import UserAccess from '../../../base/errors/airdome/UserAccess';

const userAccess: UserAccess = {
  unableToLoad: 'Uživatelé s přístupem se nepodařili načíst'
};

export default userAccess;
